export default "__VITE_ASSET__DLalI5XI__"